"use client";
import { motion } from "framer-motion";
import type { ReactElement, ReactNode } from "react";
import type { CmarkdownvisualMetric } from "./Cmarkdownvisual.types";
import { Cbutton } from "@/components/ui/Cbutton";
import { ButtonPreset } from "@/constants/componentPresets";
import { GRID_OVERLAY_STYLE, SPRING_EASE, CmarkdownvisualHoverState, WIDGET_BODY_STYLE, WIDGET_DOT_STYLE, WIDGET_EXPAND_BTN_STYLE, WIDGET_HEAD_STYLE, WIDGET_METRIC_NUM_STYLE, WIDGET_METRIC_STYLE, WIDGET_METRIC_UNIT_STYLE, WIDGET_SHADOW_BY_HOVER_STATE, WIDGET_STYLE, WIDGET_TAG_STYLE, WIDGET_WRAP_STYLE, } from "./CmarkdownvisualStyles";
interface CmarkdownvisualCompactProps {
    className?: string;
    compactPreview: ReactNode;
    metric?: CmarkdownvisualMetric;
    onExpand: () => void;
    type: string;
}
export function CmarkdownvisualCompact({ className, compactPreview, metric, onExpand, type, }: CmarkdownvisualCompactProps): ReactElement {
    return (
      <motion.div key="compact" className={className} style={WIDGET_WRAP_STYLE} initial={{ opacity: 0, scale: 0.88, y: 16 }} whileInView={{ opacity: 1, scale: 1, y: 0 }} viewport={{ once: true, margin: "-10% 0px" }} exit={{ opacity: 0, scale: 0.88 }} transition={{ duration: 0.36, ease: SPRING_EASE }}>
        <Cbutton preset={ButtonPreset.Ghost} ariaLabel="Expand visual" onClick={onExpand} padding={0} radius={14} disableClickMotion style={{ flexShrink: 0 }} containerStyle={{ ...WIDGET_STYLE, boxShadow: WIDGET_SHADOW_BY_HOVER_STATE[CmarkdownvisualHoverState.Idle] }} contentStyle={{ display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "flex-start", width: "100%", height: "100%" }} stateContainerStyle={{ hover: { boxShadow: WIDGET_SHADOW_BY_HOVER_STATE[CmarkdownvisualHoverState.Hovered] } }}>
          <div style={WIDGET_HEAD_STYLE}>
            <div style={WIDGET_TAG_STYLE}>
              <div style={WIDGET_DOT_STYLE}/>
              {type}
            </div>
              <div style={WIDGET_EXPAND_BTN_STYLE} aria-hidden>
              <svg width="14" height="14" viewBox="0 0 10 10" fill="none">
                <path d="M2 8L8 2M8 2H5M8 2V5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <div style={WIDGET_BODY_STYLE}>
            <div style={GRID_OVERLAY_STYLE}/>
            {compactPreview}
            {metric ? (<div style={WIDGET_METRIC_STYLE}>
                <div style={WIDGET_METRIC_NUM_STYLE}>{metric.value}</div>
                <div style={WIDGET_METRIC_UNIT_STYLE}>{metric.unit}</div>
              </div>) : null}
          </div>
        </Cbutton>
      </motion.div>
    );
}
